import React, { useState } from "react";
import { FaTrophy } from "react-icons/fa"; // Trophy icon for celebration
import ProfilePicture from "../components/ProfilePicture";
import ThemeToggle from "../components/ThemeSwitcher/ThemeSwitcher";
import { useTheme } from "../context/ThemeContext";
import { getResult } from '../api/api';
import { useParams } from "react-router-dom";
import LoaderModal from "../components/LoaderModal";

const ResultPage = () => {
    const [result, setResult] = useState([]);
    const { sessionId } = useParams();
    const [loader, setLoader] = useState(false);

    React.useEffect(() => {
        getResults();
    }, [sessionId]);

    const getResults = async () => {
        const payload = {
            sessionId,
            learnerId: localStorage.getItem("learnerId"),
            learnerName: localStorage.getItem("learnerName")
        }
        try {
            setLoader(true);
            const response = await getResult(payload);
            if (response.status === 500) {
                return
            }
            setResult(response)
        } catch (error) {

        } finally {
            setLoader(false);
        }

    }

    const marksObtained = result?.correctAnswers; // Hardcoded for now
    const totalMarks = result?.totalQuestions;
    const { themeStyles } = useTheme();

    // Conditional message based on marks
    const message = marksObtained > totalMarks / 2 ? "Congratulations!" : "Retry Quiz";
    // const resultClass = marksObtained > totalMarks / 2 ? "bg-green-500" : "bg-red-500";

    return (
        <div className="h-screen flex flex-col" style={{
            background: themeStyles.background,
            color: themeStyles.text,
        }}>
            {loader && <LoaderModal notLeftMargin={true} />}

            <div className="w-full bg-custom-blue text-white p-4 flex items-center relative fixed top-0 left-0 z-10">
                {/* Left: Profile Picture */}
                <div className="flex-shrink-0">
                    <ProfilePicture quiz={true} learnerName={localStorage.getItem("learnerName")} />
                </div>

                {/* Right: Button and ThemeToggle */}
                <div className="ml-auto flex items-center space-x-4">
                    <ThemeToggle page="studentPage" />
                </div>

            </div>
            <div className="mt-20 flex items-center justify-center py-10 pt-0">
                {/* Main Card */}
                <div className="w-full max-w-3xl bg-gradient-to-r from-blue-400 to-blue-600 p-8 rounded-xl shadow-xl relative">
                    {/* Background Circle Decoration */}
                    <div className="absolute inset-0 bg-white opacity-10 rounded-full blur-md"></div>

                    {/* Header */}
                    <div className="text-center mb-6 relative z-10">
                        <h1 className="text-5xl font-extrabold text-white mb-4">Quiz Completed!</h1>
                        <div className="flex justify-center items-center space-x-2">
                            <FaTrophy className="text-4xl text-yellow-400" />
                            <p className="text-3xl text-white font-semibold">{message}</p>
                        </div>
                    </div>

                    {/* Marks Section */}
                    <div className="text-center mb-6 relative z-10">
                        <p className="text-6xl font-bold text-white mb-2">
                            {marksObtained} / {totalMarks}
                        </p>
                        <p className="text-xl text-white">{marksObtained > totalMarks / 2 ? "You did an amazing job !" : "You have to try better next time !"}</p>
                    </div>

                    {/* Time Taken Section */}
                    {/* <div className="text-center mb-6 relative z-10">
                        <h3 className="text-lg text-white font-semibold">Time Taken</h3>
                        <p className="text-2xl font-bold text-white">{timeTaken}</p>
                    </div> */}

                    {/* Buttons Section */}
                    <div className="flex justify-between mt-6 relative z-10">
                        <button className="bg-white text-blue-600 py-2 px-6 rounded-lg font-semibold text-lg hover:bg-blue-100 transition duration-300 w-full md:w-auto mx-auto">
                            Review All Questions
                        </button>
                        {/* <button className={`${resultClass} text-white py-2 px-6 rounded-lg font-semibold text-lg hover:bg-opacity-80 transition duration-300 w-full md:w-auto`}>
                            Retry Quiz
                        </button> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResultPage;
